import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PricingConstant, PricingPlanType } from 'src/app/constants/pricing.constants';

@Component({
  selector: 'app-pricing-plans',
  templateUrl: './pricing-plans.component.html',
  styleUrls: ['./pricing-plans.component.scss']
})
export class PricingPlansComponent implements OnInit {

  constPricing = PricingConstant;
  isMonthly: boolean = false;

  constructor(private _location: Location,
    private router: Router) { }  

  ngOnInit(): void {
  }

  /**
   * @description handle browser back button 
   */
  goBack() {
    this._location.back();
  }

  /**
   * @description goto checkout page
   */
  gotoCheckout() {
    this.router.navigateByUrl(`report/payment/checkout/${PricingPlanType.PROFESSIONAL_PLAN}`);
  }


}
